import React, { useContext, useId } from 'react';
import 'twin.macro';
import { DividerTitle } from '../divider';
import { ScrollBarContent } from '../scroll';
import { AppContext, UserContext } from '../context';
import { featuresNavList } from '../../data/';
import { SidebarNavLink } from '../linktypes';

export const SideBarFeaturesNavigation = () => {
  const id = useId();
  const { user } = useContext(UserContext);
  return (
    <>
      {user &&
        featuresNavList(user).map((feature) => {
          const { ElementType, label, pathname } = feature;
          return (
            <ElementType key={label + id} to={pathname}>
              {label}
            </ElementType>
          );
        })}
    </>
  );
};

export const SideBarFeatures = ({ showOnAllDevices = false }) => {
  const { windowSize } = useContext(AppContext);
  const showContent = ['DESKTOP'].includes(windowSize.adBreakPoint);
  const { user } = useContext(UserContext);

  return (
    <>
      {(showContent || showOnAllDevices) && (
        <ScrollBarContent tw='sticky top-0 sm:top-14 z-30 md:h-[calc(100vh - 9.8rem)] pt-4'>
          <DividerTitle title='Reaguurder' />
          <SidebarNavLink to='/reaguurder/instellingen'>Reaguurderinstellingen</SidebarNavLink>
          <SidebarNavLink to={`/profiel/${user?.name}`}>Mijn profiel</SidebarNavLink>
          <DividerTitle title='Features' tw='mt-4' />
          <SideBarFeaturesNavigation />
        </ScrollBarContent>
      )}
    </>
  );
};
